export const languages = [
  {
    imageUrl: "https://elephy.tech/assets/images/services-ico/python.png",
    imageAlt: "Python",
    overlayColor: "overlay blue lighten-5",
    overlayDesc: `Python is one of the first programming language I was taught.
    Notably my dad had procured a basic Python programming book when
    I was 14 which I forgot mostly about due to lack of use. Now I
    use it with my design team Unmanned Aircraft System using Django
    framework and also in my applied machine learning class where we
    use PyTorch.`,
  },
  {
    imageUrl:
      "https://upload.wikimedia.org/wikipedia/commons/1/18/ISO_C%2B%2B_Logo.svg",
    imageAlt: "Cpp",
    overlayColor: "overlay teal lighten-5",
    overlayDesc: `Ah C++! I'm currently using it in my introduction to algorithm
    and data structure course. It is definitely the hardest language
    for me to get used to but I love the efficiency and control.
    Plus they are great for honing your algorithm and debugging
    skills. (Thanks seg faults)`,
  },
  {
    imageUrl:
      "https://cdn.iconscout.com/icon/free/png-512/c-programming-569564.png",
    imageAlt: "C",
    overlayColor: "overlay lime lighten-5",
    overlayDesc: `Funny thing is C is what my first year programming class was
    taught in but it wasn't until this term where I get the hang of
    C through learning C++ and the very involved labs at my Basics
    of Computer Systems course. I will never forget writing a
    debugger for assembly in C.`,
  },
  {
    imageUrl:
      "https://blog.canadianwebhosting.com/wp-content/uploads/2018/04/javascript-logo.png",
    imageAlt: "JavaScript",
    overlayColor: "overlay cyan lighten-5",
    overlayDesc: `The first (actually the first this time!) programming language I
    ever learned, but haven't gotten very good at it until this term
    when I learned about ES6+ and React.`,
  },
  {
    imageUrl: "https://www.w3.org/html/logo/downloads/HTML5_Logo_512.png",
    imageAlt: "HTML",
    overlayColor: "overlay2 deep-purple lighten-4",
    overlayDesc: `I don't consider this to be a programming language but I do like
    a good webpage (like this one:p). I learned this along with
    JavaScript. I do do lots of XML in React tho.`,
  },
  {
    imageUrl:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1200px-CSS3_logo_and_wordmark.svg.png",
    imageAlt: "CSS",
    overlayColor: "overlay orange lighten-5",
    overlayDesc: `First picked up with JavaScript, there is still much to
    learn about the art of user experience and interface design.`,
  },
  {
    imageUrl: "https://split.io/wp-content/uploads/2020/08/go-logo.png",
    imageAlt: "Go",
    overlayColor: "overlay2 cyan lighten-4",
    overlayDesc: `A language I looked into at a workshop, will be using it in my upcoming 
    co-op at Zaber!`,
  },
  {
    imageUrl: "https://cdn.iconscout.com/icon/free/png-256/java-60-1174953.png",
    imageAlt: "Java",
    overlayColor: "overlay pink lighten-5",
    overlayDesc: `Java is the first language I became proficient at. I picked up
    Java first term of second year in my Software Engineering
    principle course and tackled increasingly challenging tasks and
    projects. Java's strong type also taught me about
    object-oriented design principles. This is also the first
    language where I was introduced concurrency.`,
  },
  {
    imageUrl: "https://miro.medium.com/max/3200/0*0XnmF8Bpqd4RVaOW.png",
    imageAlt: "X86",
    overlayColor: "overlay2 red lighten-4",
    overlayDesc: `Yes x86 logo looks cool but I chose this not only because I
    learned x86, but also because ARM and Verilog do not have pretty
    logos! I'm not bad at these low level languages. I just love the
    software side of computer engineering way more.`,
  },
];
